import { useEffect, useState } from 'react';

/** `null` where the browser API is missing (server render, jsdom tests). */
const queryList = (mediaQuery: string) =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(mediaQuery)
    : null;

/**
 * A hook that tracks whether the given media query matches the current window size.
 *
 * @param {string} mediaQuery - The media query to track.
 * @returns - Whether the media query matches the current window size.
 */
export function useMediaQuery(mediaQuery: string) {
  const [matches, setMatches] = useState(
    () => !!queryList(mediaQuery)?.matches
  );

  useEffect(() => {
    const mql = queryList(mediaQuery);
    if (!mql) return;

    const handleChange = ({ matches }: MediaQueryListEvent) =>
      setMatches(matches);

    setMatches(mql.matches);
    mql.addEventListener('change', handleChange);
    return () => mql.removeEventListener('change', handleChange);
  }, [mediaQuery]);

  return matches;
}
